import type { CSSProperties } from 'react';

import DrupalImage from '@commons/components/Image/Drupal';
import type { DrupalBlock, DrupalImage as DrupalImageType } from '@commons/types/drupal';

/**
 * PageImageFieldBlock field block.
 */

const PageImageFieldBlock = ({ content }: DrupalBlock<DrupalImageType>) => {
  if (!content?.url) return null;

  const { width, height } = content;

  // Calculate the aspect ratio based on the image dimensions.
  // This is required to avoid layout shifts and to ensure that anchors scroll to the correct position.

  const inlineStyles: CSSProperties = {
    aspectRatio: `${width} / ${height}`,
  };

  return <DrupalImage {...content} className="w-100" style={inlineStyles} />;
};

export default PageImageFieldBlock;
